// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"269b30ae","91":"997e15db","239":"015ca477","389":"22e824c7","453":"ed5f8288","455":"fbb9d860","670":"c373ac98","680":"db0f0b41","682":"5fc38ab8","729":"2c9fd9e5","779":"29db4b5b","790":"0d707b41","850":"e5fc6f38","977":"81f2a5a2"}[chunkId] + ".chunk.js";
};